import type { IconProps } from "@tamagui/helpers-icon";
import { WithMediaProps } from "@tamagui/web";
import { Circle } from "tamagui";

import { getShadow } from "@/theme/helpers";
import { isMobileWeb } from "@/utils/web";

type WithMediaAndIconProps = WithMediaProps<IconProps> & IconProps;

const IconButton = Circle.styleable<{
  Icon: React.ComponentType<IconProps>;
  iconSize?: IconProps["size"];
}>(({ Icon, iconSize = "$300", ...props }, ref) => {
  const IconWithGroupProps = Icon as React.ComponentType<WithMediaAndIconProps>;
  return (
    <Circle
      ref={ref}
      tabIndex={props.disabled ? -1 : 0}
      cursor="pointer"
      backgroundColor="$fillModal"
      group="iconButton"
      height="$500"
      width="$500"
      hoverStyle={{ backgroundColor: "$textLink", borderColor: "$textLink" }}
      {...getShadow({ blur: 12 })}
      borderColor="$strokeNeutral"
      borderWidth="$strokeWidth"
      outlineOffset="$25"
      focusVisibleStyle={{
        outlineColor: "$outlineColor",
        outlineStyle: "solid",
        outlineWidth: 2,
      }}
      disabledStyle={{
        borderWidth: 0,
        shadowColor: "$transparent",
        backgroundColor: "$fillButtonDisabled",
        cursor: "not-allowed",
      }}
      {...props}
    >
      <IconWithGroupProps
        size={iconSize}
        flexShrink={0}
        color="$textLink"
        $group-iconButton-disabled={{ color: "$textButtonDisabled" }}
        // https://github.com/tamagui/tamagui/issues/3722
        {...(!isMobileWeb()
          ? { "$group-iconButton-hover": { color: "$fillModal" } }
          : {})}
      />
    </Circle>
  );
});

export default IconButton;
